<script src="../../country.js"></script>
<template>
    <div v-show="isCountryShow">
        <transition name="fadeInUp">
            <div class="country">
                <div class="search">
                    <input type="text" placeholder="模糊搜索" @input="searchInput('serach')" v-model="countryInput">
                </div>
                <ul v-if="!isSearch">
                    <li class="title">常用国家/地区</li>
                    <li v-for="(val,index) in countryList.freCountry" :title="val.CNName" @click="CountryCheck(val)">{{val.CNName}}</li>
                    <li class="title">所有国家/地区 (A-Z)</li>
                    <li v-for="(val,index) in countryList.country" :title="val.CNName" @click="CountryCheck(val)">{{val.CNName}}</li>
                </ul>
                <ul  v-if="isSearch">
                    <li v-for="(val,index) in countryListAll" :title="val.CNName" @click="CountryCheck(val)">{{val.CNName}}</li>
                    <li v-if="countryListAll.length==0">无</li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
    const country = require('./../../country.js')
    export default {
        name: "country",
        props:{
            isCountryShow:{
                type:Boolean,
                default:false,
            },
        },
        data: function () {
            return {
                countryList: country,
                countryListAll:country.country,
                isSearch:false,
                countryInput:'',
            }
        },
        watch:{
            countryInput(val){
                if(val == ''){
                    this.isSearch = false;
                }else{
                    this.isSearch = true;
                }
            }
        },
        mounted() {
            this.searchInput('init');
        },
        methods: {
            searchInput(type){
                var that = this;
                var params = {}
                if(type == 'init'){
                    params = {}
                }else{
                    params = {
                        q: that.countryInput
                    }
                }
                that.getRequest({
                    url: that.Api.getCountry,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        if(type == 'init'){
                            that.countryList.country = res.Result
                            that.$nextTick(() => {
                                if(localStorage.getItem('lang')=='t'){
                                    that.$zh_tran(localStorage.getItem('lang'))
                                }    
                            })
                        }else{
                            that.countryListAll = res.Result;
                            that.$nextTick(() => {
                                if(localStorage.getItem('lang')=='t'){
                                    that.$zh_tran(localStorage.getItem('lang'))
                                }    
                            })
                        }
                    }
                });
            },
            CountryCheck(obj){
                this.$emit('select',obj);
            }
        }
    }
</script>

<style scoped>
    .country{
        position: absolute;
        top: 36px;
        left: -1px;
        width: 180px;
        border: 1px solid #e6e6e6;
        background: #FFF;
        z-index: 2;
    }
    .country .search{
        border-bottom: 1px solid #e6e6e6;
        height: 36px;
    }
    .country .title{
        background: #f2f6f9;
        margin: 0;
    }
    .country .search input{
        padding: 0px 10px;
        height: 30px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        width: 178px;
    }
    .country ul{
        max-height: 300px;
        overflow-y: auto;
    }
    .country li{
        padding: 0 10px;
        width: 100%;
        overflow: hidden;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
    }
    .country li:hover{
        color: #fff;
        background: #1270f8;
    }
    .country .title:hover{
        background: #f2f6f9;
        color: #333;
        cursor: initial;
    }
</style>


// WEBPACK FOOTER //
// src/common/cmpnt/searchBox/country.vue